(function ($, document, window) {
  var servicenav = {
    init: function () {
      $('.c-service-nav__item').click(function (event) {
        var index = $(this).attr('data-num');
        servicenav.updateIndicator(index);
      });

      $('.js-puff').click(function (e) {
        //e.preventDefault();
          if($(window).width() > 768){
            $('.js-puff.active').removeClass('active');
            $(this).addClass('active');
    
          }
      
        // var index = $(this).attr('data-num');
        // servicenav.updateIndicator(index);
      });

      $('input.FormTextbox__Input[type=text], .FormTextbox--Textarea textarea').on('focus', function () {
        $(this).parent().addClass('has-focus');
      });
      $('input.FormTextbox__Input[type=text], .FormTextbox--Textarea textarea').on('focusout', function () {
        if ($(this).val().length === 0) {
          $(this).parent().removeClass('has-focus');
        }
      });

      function autosize(){
        var text = $('.FormTextbox--Textarea textarea');
    
        text.each(function(){
            $(this).attr('rows',1);
            resize($(this));
        });
    
        text.on('input', function(){
            resize($(this));
        });
        
        function resize ($text) {
            $text.css('height', 'auto');
            $text.css('height', $text[0].scrollHeight+'px');
        }
    }
    autosize(); 
 
      $(document).ready(function () {
        objectFitImages();
      });
    },
    updateIndicator: function (index) {
      $('.c-indicator__item.active').removeClass('active');
      $('.c-indicator__item[data-num=' + index + ']').addClass('active');
    },
  };
  servicenav.init();
})(jQuery, document, window);
